// extracted by mini-css-extract-plugin
module.exports = {"root":"SchemaList_root__26LVp","keyword":"SchemaList_keyword__3GSsL","keywordIcon":"SchemaList_keywordIcon__bDp2u"};